import { useState, useEffect } from 'react';
import axios from 'utils/axios';

const EventAdminCreateService = async (value) => {
    await axios.post('api/event', value).catch((error) => {
        console.log(error);
    });
    // const getData = async (url, action) => {
    //   await axios.get(url).then(response => {
    //     action(response.data);
    //   });
    // };

    // useEffect(() => {
    //   getData('api/event', setListData);
    // },[]);

    return true;
};

export default EventAdminCreateService;
